import React from 'react';
import { MapPin, Clock, Users, Calendar as CalendarIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

const SGLoopCard = ({ community }) => {
  // now community is the object passed from ThirdSection
  return (
    <Link to="/SGLoop">
    <div className="max-w-sm rounded-3xl overflow-hidden bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer">
      {/* Image */}
      <img
        className="w-full h-44 sm:h-48 object-cover"
        src={community.image}
        alt={community.areaName}
      />

      {/* Content */}
      <div className="p-5">
        <h3 className="text-lg font-bold text-gray-900">{community.areaName}</h3>
        
        {/* Info */}
        {/* <div className="mt-3 space-y-2 text-gray-600 text-sm">
          {community.upcomingEvents > 0 && (
            <div className="flex items-center gap-2">
              <CalendarIcon className="w-4 h-4 text-blue-500" />
              <span>{community.upcomingEvents} upcoming event{community.upcomingEvents > 1 ? 's' : ''}</span>
            </div>
          )}
          {community.location && (
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-red-500" />
              <span>{community.location}</span>
            </div>
          )}
          {community.pax && (
            <div className="flex items-center gap-2">
              <Users className="w-4 h-4 text-green-500" />
              <span>{community.pax} members</span>
            </div>
          )}
          {community.nextEventDate && (
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-yellow-500" />
              <span>Next: {community.nextEventDate}</span>
            </div>
          )}
        </div> */}
      </div>
    </div>
    </Link>
  );
};

export default SGLoopCard;
